import React, { useState, useEffect } from 'react'
import * as api from '../../services/api.js'
import { todayISO } from '../../utils/dates.js'

const today = todayISO()

export const SYSTEM_TEMPLATES = [
  {
    id: 'sys-daily',
    title: 'Daily reflection',
    description: 'Capture your day — mood, gratitude, and tomorrow\'s intention',
    icon: '🌿',
    cover_color: '#e8f5ed',
    blocks: [
      { block_type: 'heading1',     content: { text: 'Today\'s reflection' } },
      { block_type: 'custom_field', content: { label: 'Date',  value: today } },
      { block_type: 'custom_field', content: { label: 'Mood',  value: '' } },
      { block_type: 'heading2',     content: { text: 'What happened today' } },
      { block_type: 'text',         content: { text: '' } },
      { block_type: 'heading2',     content: { text: 'What I\'m grateful for' } },
      { block_type: 'checklist',    content: { items: [{ text: '', checked: false }, { text: '', checked: false }, { text: '', checked: false }] } },
      { block_type: 'heading2',     content: { text: 'Tomorrow\'s intention' } },
      { block_type: 'text',         content: { text: '' } },
    ],
  },
  {
    id: 'sys-weekly',
    title: 'Weekly review',
    description: 'Celebrate wins, acknowledge challenges, plan ahead',
    icon: '📋',
    cover_color: '#e8f0f5',
    blocks: [
      { block_type: 'heading1',  content: { text: `Week of ${today}` } },
      { block_type: 'heading2',  content: { text: 'Wins this week' } },
      { block_type: 'checklist', content: { items: [{ text: '', checked: false }, { text: '', checked: false }, { text: '', checked: false }] } },
      { block_type: 'heading2',  content: { text: 'What was hard' } },
      { block_type: 'text',      content: { text: '' } },
      { block_type: 'heading2',  content: { text: "Next week's focus" } },
      { block_type: 'text',      content: { text: '' } },
      { block_type: 'divider',   content: {} },
      { block_type: 'callout',   content: { icon: '💡', text: 'One thing I want to do differently', color: '#fef9c3' } },
    ],
  },
  {
    id: 'sys-book',
    title: 'Book notes',
    description: 'Capture key ideas, quotes, and your thoughts on a book',
    icon: '📚',
    cover_color: '#f5f0e8',
    blocks: [
      { block_type: 'heading1',     content: { text: 'Book title' } },
      { block_type: 'custom_field', content: { label: 'Author',   value: '' } },
      { block_type: 'custom_field', content: { label: 'Started',  value: '' } },
      { block_type: 'custom_field', content: { label: 'Finished', value: '' } },
      { block_type: 'custom_field', content: { label: 'Rating',   value: '' } },
      { block_type: 'divider',      content: {} },
      { block_type: 'heading2',     content: { text: 'Key ideas' } },
      { block_type: 'text',         content: { text: '' } },
      { block_type: 'heading2',     content: { text: 'Favourite quotes' } },
      { block_type: 'text',         content: { text: '' } },
      { block_type: 'heading2',     content: { text: 'My thoughts' } },
      { block_type: 'text',         content: { text: '' } },
    ],
  },
  {
    id: 'sys-project',
    title: 'Project planner',
    description: 'Organise tasks, set a deadline, and track progress',
    icon: '🗺',
    cover_color: '#ede8f5',
    blocks: [
      { block_type: 'heading1',     content: { text: 'Project name' } },
      { block_type: 'custom_field', content: { label: 'Status',   value: 'In progress' } },
      { block_type: 'custom_field', content: { label: 'Deadline', value: '' } },
      { block_type: 'custom_field', content: { label: 'Goal',     value: '' } },
      { block_type: 'divider',      content: {} },
      { block_type: 'heading2',     content: { text: 'Tasks' } },
      { block_type: 'checklist',    content: { items: Array(5).fill(null).map(() => ({ text: '', checked: false })) } },
      { block_type: 'heading2',     content: { text: 'Notes' } },
      { block_type: 'text',         content: { text: '' } },
      { block_type: 'toggle',       content: { title: 'Resources', content: '', open: false } },
    ],
  },
  {
    id: 'sys-recipe',
    title: 'Recipe notes',
    description: 'Save ingredients, method, and personal variations',
    icon: '🍳',
    cover_color: '#f5f0e0',
    blocks: [
      { block_type: 'heading1',     content: { text: 'Recipe name' } },
      { block_type: 'custom_field', content: { label: 'Cuisine', value: '' } },
      { block_type: 'custom_field', content: { label: 'Serves',  value: '' } },
      { block_type: 'custom_field', content: { label: 'Time',    value: '' } },
      { block_type: 'divider',      content: {} },
      { block_type: 'heading2',     content: { text: 'Ingredients' } },
      { block_type: 'checklist',    content: { items: Array(5).fill(null).map(() => ({ text: '', checked: false })) } },
      { block_type: 'heading2',     content: { text: 'Method' } },
      { block_type: 'text',         content: { text: '' } },
      { block_type: 'heading2',     content: { text: 'Notes & variations' } },
      { block_type: 'text',         content: { text: '' } },
    ],
  },
  {
    id: 'sys-habit',
    title: 'Habit plan',
    description: 'Define a new habit, set your why, and plan for obstacles',
    icon: '✨',
    cover_color: '#fde8e8',
    blocks: [
      { block_type: 'heading1',     content: { text: 'My habit plan' } },
      { block_type: 'custom_field', content: { label: 'Starting', value: '' } },
      { block_type: 'custom_field', content: { label: 'Goal',     value: '' } },
      { block_type: 'divider',      content: {} },
      { block_type: 'heading2',     content: { text: 'Why this matters' } },
      { block_type: 'text',         content: { text: '' } },
      { block_type: 'heading2',     content: { text: 'My plan' } },
      { block_type: 'text',         content: { text: '' } },
      { block_type: 'heading2',     content: { text: 'Potential obstacles' } },
      { block_type: 'checklist',    content: { items: [{ text: '', checked: false }, { text: '', checked: false }, { text: '', checked: false }] } },
      { block_type: 'callout',      content: { icon: '🌿', text: 'Remember: small and consistent beats perfect and sporadic', color: '#e8f5ed' } },
    ],
  },
]

export default function TemplatesPicker({ onClose, onCreated }) {
  const [customTemplates, setCustomTemplates] = useState([])
  const [loading, setLoading] = useState(false)
  const [creatingId, setCreatingId] = useState(null)

  useEffect(() => {
    api.getMySpaceTemplates().then(d => setCustomTemplates(d || []))
  }, [])

  async function useTemplate(tmpl) {
    if (creatingId) return
    setCreatingId(tmpl.id)
    setLoading(true)
    try {
      const pageRes = await api.createMyPage({
        title:       tmpl.title,
        icon:        tmpl.icon,
        cover_color: tmpl.cover_color,
        layout:      'cosy',
        pinned:      0,
      })
      const pageId = pageRes?.id
      if (!pageId) throw new Error('no page id')

      const blocks = tmpl.blocks || (tmpl.data ? (typeof tmpl.data === 'string' ? JSON.parse(tmpl.data) : tmpl.data).blocks || [] : [])
      for (let i = 0; i < blocks.length; i++) {
        await api.createPageBlock({
          page_id:    pageId,
          block_type: blocks[i].block_type,
          content:    blocks[i].content,
          position:   i,
        })
      }
      onCreated(pageId)
    } catch (err) {
      console.error('Template creation failed', err)
    } finally {
      setLoading(false)
      setCreatingId(null)
    }
  }

  async function deleteCustomTemplate(id) {
    await api.deleteMySpaceTemplate(id)
    setCustomTemplates(prev => prev.filter(t => t.id !== id))
  }

  return (
    <div>
      <div className="template-section-label">System templates</div>
      <div className="template-grid">
        {SYSTEM_TEMPLATES.map(tmpl => (
          <div key={tmpl.id} className="template-card">
            <div className="tc-cover" style={{ background: tmpl.cover_color }} />
            <div className="tc-body">
              <div className="tc-title">{tmpl.icon} {tmpl.title}</div>
              <div className="tc-desc">{tmpl.description}</div>
              <button
                className="save-btn ready"
                style={{ fontSize: '0.78rem', padding: '5px 12px' }}
                disabled={loading}
                onClick={() => useTemplate(tmpl)}
              >
                {creatingId === tmpl.id ? 'Creating…' : 'Use template'}
              </button>
            </div>
          </div>
        ))}
      </div>

      {customTemplates.length > 0 && (
        <>
          <div className="template-section-label">My templates</div>
          <div className="template-grid">
            {customTemplates.map(tmpl => (
              <div key={tmpl.id} className="template-card" style={{ position: 'relative' }}>
                <div className="tc-cover" style={{ background: '#f5f0e8' }} />
                <div className="tc-body">
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <div className="tc-title">📄 {tmpl.title}</div>
                    <button
                      onClick={() => deleteCustomTemplate(tmpl.id)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--stone)', fontSize: '0.7rem', padding: '0 2px', flexShrink: 0 }}
                      title="Delete template"
                    >
                      ✕
                    </button>
                  </div>
                  {tmpl.description && <div className="tc-desc">{tmpl.description}</div>}
                  <button
                    className="save-btn ready"
                    style={{ fontSize: '0.78rem', padding: '5px 12px' }}
                    disabled={loading}
                    onClick={() => useTemplate(tmpl)}
                  >
                    {creatingId === tmpl.id ? 'Creating…' : 'Use template'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
